import React from 'react';
import { StyledSystemProps } from '../../../../../types';
import Avatar from '../../../../../wag-react/components/Avatar';
export type VetProfileAvatarProps = {
  src: string;
} & StyledSystemProps;
export const VetProfileAvatar = ({
  src,
  ...rest
}: VetProfileAvatarProps) => <Avatar bg="#d4d4d4" containerProps={{
  border: '2px solid #EDEDED'
}} src={src} height="70px" iconHeight="70px" iconWidth="70px" width="70px" {...rest} data-sentry-element="Avatar" data-sentry-component="VetProfileAvatar" data-sentry-source-file="VetProfileAvatar.tsx" />;